import axios from './axiosConfig';

const API_URL = '/groupPlayers/';

const getAllGroupPlayers = () => {
    return axios.get(API_URL);
}

const updatePlayersOrder = async (groupId, orderList) => {
    return await axios.put(API_URL + groupId + '/players/order', orderList);
};

export default {
    getAllGroupPlayers,
    updatePlayersOrder,
};